<!-- loading data layout start -->
@if (loadingData) {
  <div class="loading-screen text-center vh-100 d-flex align-items-center justify-content-center">
    <div>
      <img class="qm-dino-loading-img" src="/assets/images/quote_monster_crunching_animation.gif?v=2" />
      <h3>Loading data.</h3>
    </div>
  </div>
}
<!-- loading data layout end -->

<!-- after loading data layout start -->
@if (loadingData === false) {
  @if (!hideRedirectMessage && isDevMode) {
    <ng-container *ngTemplateOutlet="redirectMessage" />
  }
  <div class="container-fluid">
    <!-- home page take over start-->
    <div class="qm-bg-white">
      <app-ad-public-show [pathName]="routerName" [adBlocker]="adBlocker" />
    </div>
    <!-- home page take over end -->
    <div class="d-flex flex-column justify-content-between min-vh-100 w-100">
      <div id="qmMainTopHeader" class="qm-header">
        <nav-menu [pathName]="routerName" [isOauth]="isOauth" />
      </div>
      <!-- here is main container start -->
      <div class="flex-fill">
        <router-outlet />
      </div>
      <!-- here is main container end -->
      <footer id="qmMainBottomFooter" class="row qm-text-white qm-bg-dark-gray qm-py-block footer">
        <div class="col">
          <!-- before login -->
          @if (!loginService.isLogin() && !isOauth) {
            <div class="container">
              <div class="row">
                <!-- nav links & social network & logo-->
                <div class="col-6 col-lg-2 pb-5">
                  <h6 class="qm-text-primary mb-4">Overview</h6>
                  <div>
                    <a class="qm-text-white mb-4 d-block" [routerLink]="['/home']" (click)="$event.target.offsetParent.blur()">
                      Quotemonster
                    </a>

                    <a class="qm-text-white mb-4 d-block" [routerLink]="['am/home']" (click)="$event.target.offsetParent.blur()">
                      Advicemonster
                    </a>
                    <a class="qm-text-white mb-4 d-block" [routerLink]="['bm/home']" (click)="$event.target.offsetParent.blur()">
                      Businessmonster
                    </a>
                    <a class="qm-text-white mb-4 d-block" [routerLink]="['km/home']" (click)="$event.target.offsetParent.blur()">
                      Kiwimonster
                    </a>
                    <!-- TODO: uncomment after creating the product page -->
                    <!-- <a class="qm-text-white" mat-list-item href="">Product</a> -->
                    <a class="qm-text-white mb-4 d-block" [routerLink]="['/pricing']" (click)="$event.target.offsetParent.blur()">
                      Pricing
                    </a>

                    <a
                      class="qm-text-white mb-4 d-block text-nowrap"
                      [href]="onlineTrainingUrl"
                      target="_blank"
                      rel="noopener"
                      referrerpolicy="no-referrer"
                      (click)="$event.target.offsetParent.blur()">
                      Book an Online Training
                    </a>
                  </div>
                </div>
                <div class="col-6 col-lg-2 pb-5">
                  <h6 class="qm-text-primary mb-4">Company</h6>
                  <div>
                    <!-- TODO: uncomment after creating the resources page -->
                    <!-- <a class="qm-text-white" mat-list-item href="">Resources</a> -->
                    <a
                      class="qm-text-white mb-4 d-block"
                      [routerLink]="['/public/about-overview']"
                      (click)="$event.target.offsetParent.blur()">
                      Our Team
                    </a>
                    <a
                      class="qm-text-white mb-4 d-block"
                      href="https://www.chatswood.co.nz/"
                      target="_blank"
                      rel="noopener"
                      (click)="$event.target.offsetParent.blur()">
                      Blog
                    </a>
                    <a
                      class="qm-text-white mb-4 d-block"
                      [routerLink]="['/public/our-independence']"
                      rel="noopener"
                      (click)="$event.target.offsetParent.blur()">
                      Independence
                    </a>
                  </div>
                </div>
                <div class="col-6 col-lg-2 pb-5">
                  <h6 class="qm-text-primary mb-4">Account</h6>
                  <div>
                    <a class="qm-text-white mb-4 d-block" [routerLink]="['/login']" (click)="$event.target.offsetParent.blur()">Login</a>
                    <a
                      class="qm-text-white mb-4 d-block"
                      href="https://quotemonster.freshdesk.com/support/home"
                      target="_blank"
                      rel="noopener"
                      (click)="$event.target.offsetParent.blur()">
                      Help
                    </a>
                    <a class="qm-text-white mb-4 d-block" [routerLink]="['/public/contact']" (click)="$event.target.offsetParent.blur()">
                      Contact
                    </a>
                  </div>
                </div>
                <div class="col-6 col-lg-6 pb-5 d-flex flex-column justify-content-around text-lg-end">
                  <!-- social network -->
                  <div>
                    <a
                      mat-fab
                      class="me-1 me-sm-3 mb-3 qm-bg-black"
                      href="https://www.linkedin.com/company/quality-product-research-ltd"
                      target="_blank"
                      rel="noopener"
                      referrerpolicy="no-referrer">
                      <img width="24" height="24" src="../assets/images/icon/linkedin-white@2x.png?v=2" title="LinkedIn" />
                    </a>
                    <a
                      mat-fab
                      class="me-1 me-sm-3 mb-3 qm-bg-black"
                      href="https://x.com/QPRQuotemonster"
                      target="_blank"
                      rel="noopener"
                      referrerpolicy="no-referrer">
                      <img width="24" height="24" src="../assets/images/icon/x-logo-white.png" title="x.com" />
                    </a>
                    <a
                      mat-fab
                      class="mb-3 social-links qm-bg-black"
                      href="https://www.youtube.com/channel/UC9gx8xqu7plB7RylVBm-BNg"
                      target="_blank"
                      rel="noopener"
                      referrerpolicy="no-referrer">
                      <img width="30" height="30" src="../assets/images/icon/youtube-white.png?v=2" title="Youtube" />
                    </a>
                  </div>
                  <!-- social network -->
                  <!-- logo -->
                  <div>
                    <img width="257" height="84" src="../assets/images/qpr-footer-logo/qpr-footer-logo@2x.png" alt="qpr logo" />
                  </div>
                  <!-- logo -->
                </div>
              </div>
              <!-- nav links & social network & logo end-->
            </div>
          }
          <!-- before login end -->
          <!-- after login and OAuth page (public authorization) -->
          @if (loginService.isLogin() || isOauth) {
            <div class="container">
              <div class="row mb-5 justify-content-center justify-content-lg-between">
                <!-- social network -->
                <div class="col-auto mb-5 mb-lg-0">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <a
                        mat-fab
                        class="me-3 qm-bg-black"
                        href="https://www.linkedin.com/company/quality-product-research-ltd"
                        target="_blank"
                        rel="noopener"
                        referrerpolicy="no-referrer">
                        <img width="24" height="24" src="../assets/images/icon/linkedin-white@2x.png?v=2" title="LinkedIn" />
                      </a>
                      <a
                        mat-fab
                        class="me-3 qm-bg-black"
                        href="https://x.com/QPRQuotemonster"
                        target="_blank"
                        rel="noopener"
                        referrerpolicy="no-referrer">
                        <img width="24" height="24" src="../assets/images/icon/x-logo-white.png" title="x.com" />
                      </a>
                      <a
                        mat-fab
                        class="qm-bg-black"
                        href="https://www.youtube.com/channel/UC9gx8xqu7plB7RylVBm-BNg"
                        target="_blank"
                        rel="noopener"
                        referrerpolicy="no-referrer">
                        <img width="30" height="30" src="../assets/images/icon/youtube-white.png?v=2" title="Youtube" />
                      </a>
                    </div>
                    <div class="col-auto">
                      <a [routerLink]="['/public/about-overview']" class="qm-text-white me-4" (click)="$event.target.blur()">Our Team</a>
                      <a [routerLink]="['/public/contact']" class="qm-text-white" (click)="$event.target.blur()">Contact</a>

                      <div class="w-100"></div>
                      <a
                        [href]="onlineTrainingUrl"
                        target="_blank"
                        rel="noopener"
                        referrerpolicy="no-referrer"
                        class="qm-text-white"
                        (click)="$event.target.blur()">
                        Book an Online Training
                      </a>
                    </div>
                  </div>
                </div>
                <!-- social network -->
                <!-- logo -->
                <div class="col-auto">
                  <img width="257" height="84" src="../assets/images/qpr-footer-logo/qpr-footer-logo@2x.png?v=2" alt="qpr logo" />
                </div>
                <!-- logo -->
              </div>
            </div>
          }
          <!-- after login end -->
          <!-- copyright & site version & terms-->
          <div class="w-100 border-top border-dark">
            <div class="container">
              <div class="row">
                <!-- copyright & site version-->
                <div class="pt-5 col-lg-7 text-center text-lg-start">
                  <h6 class="qm-text-white text-uppercase">
                    Copyright &copy; {{ copyrightYear }} All Rights Reserved by Quality Product Research Limited
                  </h6>
                  <h6 class="qm-text-white text-uppercase">
                    Quote Engine v.{{ quoteEngineVersion }} &nbsp;&nbsp;| &nbsp;&nbsp; QPR v.{{ qprDbVersion }} &nbsp;&nbsp;| &nbsp;&nbsp;
                    Web v.{{ webVersion }}
                    <!-- <span class="d-none d-lg-inline">&nbsp;&nbsp;| &nbsp;&nbsp;</span>
                    <div class="w-100 d-block d-lg-none pt-2"></div>
                    <a class="qm-text-primary" href="https://status.quotemonster.co.nz/" target="_blank" referrerpolicy="no-referrer">
                      Service Status
                    </a> -->
                  </h6>
                </div>
                <!-- copyright & site version end-->
                <!-- terms -->
                <div class="col-lg-5 pt-5 ms-lg-auto text-center text-lg-end">
                  <div class="d-flex flex-column justify-content-between h-100">
                    <h6 class="text-uppercase">
                      <a class="qm-text-primary" href="/TermsOfUse.html" target="_blank" rel="noopener">Terms of Use & Privacy Policy</a>
                    </h6>
                    <h6 class="text-uppercase">
                      <a class="qm-text-primary" href="{{ outsourcePASUrl }}" target="_blank" rel="noopener">
                        Outsource Provider Assurance Statement
                      </a>
                    </h6>
                  </div>
                </div>
                <!-- terms end-->
              </div>
            </div>
          </div>
          <!-- copyright & site version & terms end-->
        </div>
      </footer>
    </div>
  </div>
}
<!-- after loading data layout end -->

<!-- dev mode only start-->
<!-- <div
class='row m-0 alert alert-danger text-center d-block fixed-bottom'
*ngIf='isDevMode'>
--- TEST SITE UI V2 for new API---
</div> -->
<!-- dev mode only end-->

<!-- SystemNotices start -->
@if (systemNoticesList.length > 0) {
  <div class="alert alert-danger rounded-0 mb-0 py-1 fixed-bottom" [ngClass]="hideSystemNotices ? 'd-none' : 'd-block'">
    <div class="row align-items-center justify-content-center">
      <div class="col-12">
        @for (notice of systemNoticesList; track notice) {
          <p class="mb-0 text-center">
            <strong>{{ notice.Subject }}</strong>
            :
            <span [innerHTML]="notice.Contents"></span>
          </p>
        }
      </div>

      <div class="col-auto">
        <button mat-icon-button class="qm-icon-warn" (click)="hideSystemNotices = !hideSystemNotices">
          <span class="material-icons" aria-label="close">clear</span>
        </button>
      </div>
    </div>
  </div>
}
<!-- SystemNotices end -->

<ng-template #redirectMessage>
  <div class="alert alert-danger rounded-0 mb-0 py-1">
    <div class="row align-items-center">
      <div class="col">
        <p class="mb-0 text-center">
          Sorry, you have reached our test site. Please click
          <a href="https://quotemonster.co.nz/home">here</a>
          to go to Quotemonster.co.nz
        </p>
      </div>
      <div class="col-auto">
        <button mat-icon-button class="qm-icon-warn" (click)="hideRedirectMessage = !hideRedirectMessage">
          <span class="material-icons" aria-label="close">clear</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>
